export default __webpack_public_path__ + "static/media/BackPacks 800 x 300 Mobile.8414049c.jpg";